import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SharedMenuService } from '../services/shared-menu.service';
import { tools } from '../services/tools';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  public parent: any;
  public localWindow: childWindows | undefined


  constructor(private sharedMenuService: SharedMenuService, private sharedMultiWindowsService: SharedMultiWindowsService, private tools: tools) {
    this.sharedMenuService.dragAndDropMvt$.subscribe((value) => {
      this.emitEvent("dragAndDropMvt", value);
    });
    this.sharedMenuService.poolDragAndDrop$.subscribe((value) => {
      this.emitEvent("poolDragAndDrop", value);
    });


  }

  public initialise(window: childWindows) {
    this.localWindow = window
    this.tools.delay(100).then(() => { this.sharedMultiWindowsService.setAppTitle(window["name"]) })
    this.dataReception();
  }

  private dataReception() {
    window.addEventListener("message", (event) => {
      const { action, key, value } = event.data;
      if ((!((event.origin == location.origin) || (location.origin == environment.apiFlowConfig.externalPoolUrl))) || action == null)
        return;
      switch (action) { //add event listners
        case "event":
          this.sharedMultiWindowsService.dispatchEvent({ key: key, value: value })
          break;
      }
    }, false);
  }


  public emitEvent(eventName: any, value: any) {
    //return; //must find a way to avoid message emission sended by parent (otherwise infinite bcl)
    this.parent.postMessage({
      action: 'observable',
      key: eventName,
      value: value
    }, "*");
  }
}


@Injectable({
  providedIn: 'root'
})
export class SharedMultiWindowsService {

  private appTitleSource = new Subject<string>();
  private eventDispatcherSource = new Subject<any>();
  private closeChildGuidSource = new Subject<string>();
  private pageNumberSource = new Subject<string>();
  private isParentStilAliveSource = new Subject<boolean>()


  constructor() { }

  appTitle$ = this.appTitleSource.asObservable();
  eventDispatcher$ = this.eventDispatcherSource.asObservable();
  closeChildGuid$ = this.closeChildGuidSource.asObservable();
  pageNumber$ = this.pageNumberSource.asObservable();
  isParentStilAlive$ = this.isParentStilAliveSource.asObservable()


  public setAppTitle(headerText: string) {
    this.appTitleSource.next(headerText);
  }

  public dispatchEvent(event: any) {
    this.eventDispatcherSource.next(event);
  }

  public sendCloseChild(guid: any) {
    this.closeChildGuidSource.next(guid);
  }

  public setPageNumber(pageNumber: string) {
    this.pageNumberSource.next(pageNumber)
  }

  public setIsParentStilAlive(alive: boolean) {
    this.isParentStilAliveSource.next(alive)
  }
}

export class SharedMultiWindowsModel {
  origin: string = ""; //subpath of url (required dor filtering datas at reception) 
  guidDestination: string = "";
  data: any;
  type?: string;
}



export interface childWindows {
  urlUntied?: string,
  guid: string,
  name: string,
  urlParent: string,
  creationDate: number, //isoDateString
  lastPing: number;  //isoDateString | null
  targetWindow?: WindowProxy | null,
  data?: any;
  view?: string;
  childParams? : any,
  componentUrl?: string;
  componentType?: string;
  componentId?: string;
  pageNumber? : string;
  typeEvents?: [string];
  closeOnNavigationChange?: boolean;
  datas?: any; //untyped additional data
}
